<template>
    <div class="flex flex-wrap flex-row gap-5">
        <single-filter-group
            v-for="filter in filters"
            :key="filter.field"
            :filters="appliedFilters"
            :selected-filter="filter"
            @filter-applied="applyFilter"
            @filter-removed="removeFilter"
            is-applied
        />

        <single-filter-group
            :filters="allowedFilters"
            @filter-applied="applyFilter"
            @filter-removed="removeFilter"
        />
    </div>
</template>

<script setup>
import SingleFilterGroup from '@/system/components/global/table/SingleFilterGroup.vue';

const emit = defineEmits(['filter-applied', 'filter-removed']);

const props = defineProps({
    filters: {
        type: Array,
        required: true
    },

    appliedFilters: {
        type: Array,
        required: true
    },

    allowedFilters: {
        type: Array,
        required: true
    }
})

function applyFilter(filter) {
    emit('filter-applied', filter)
}

function removeFilter(selectedFilterKey) {
    emit('filter-removed', selectedFilterKey)
}
</script>
